import ProfileAvatar from './ProfileAvatar';
import ProfileName from './ProfileName';
import MemberProfileDetail from './MemberProfileDetail';

interface Props {
    profileId: string;
    threadId: string;
}

const MemberItem = ({ threadId, profileId }: Props) => (
    <div className="media">
        <div className="pull-left">
            <ProfileAvatar threadId={threadId} profileId={profileId} size="small" />
        </div>
        <div className="media-body">
            <ProfileName threadId={threadId} profileId={profileId} />
            <br />
            <small>
                <MemberProfileDetail profileId={profileId} />
            </small>
        </div>
    </div>
);

export default MemberItem;
